module.exports = __webpack_public_path__ + "img/one.7c54123b.svg";